import React from "react"; 
// import "./ExpensesMasterfile.css";
import "../../GlobalCss/SPF/ExpensesMasterfile.css";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { Layout,Button } from "antd";
import { Link } from "react-router-dom";
import ExpensesMfTable from "../../Components/ExpensesMasterfileTable/ExpensesMfTable";
import Cookies from "js-cookie";


const {Header, Content  } = Layout;

const ExpensesMasterfile = () => {
  const tenantName = Cookies.get("tenant_name");

    return (<>
        <Layout style={{backgroundColor: "white", height: "100vh", display :"flex", overflow: "hidden"}}>
            <SideNavBar/>
            <Layout style={{backgroundColor: "white", overflow:"hidden"}}>

                <Header className="preview-header-class"><Navbar/>
                
                </Header>
                <Content style={{overflow: "auto", height: "100%"}}>
                    <h1 className="Expenses-header">Expenses Payroll</h1>
                    <div className="otherpage-buttons">
                        <Link to={`/${tenantName}/expensescrawl`}><Button className="page-button">Selected Crawling</Button></Link>
                        <Link to={`/${tenantName}/expensesautocrawl`}> <Button className="page-button">Expenses AutoCrawl</Button></Link>
                         <Button className="currentpage-button">Consolidation Data</Button>
                    </div>
                    <br></br>
                    <div className="billing-header-class">
                        <span className="Expenses-headers">Consolidation Data</span>
                    </div>
                    <div>
                        <ExpensesMfTable/>
                    </div>
                </Content>
            </Layout>
        </Layout>
    </>)
}
export default ExpensesMasterfile